import { Route, Routes } from 'react-router-dom';
import BillingReadinessReport from '../billing-readiness/BillingReadinessReport';
import RequirePermission from '../common/RequirePermission';
import AnalyticsDashboard from './AnalyticsDashboard';
import AnalyticsMain from './AnalyticsMain';
import DbStatsDashboard from './DbStatsDashboard';
import OnboardingDashboard from './OnboardingDashboard';
import SalesDashboard from './SalesDashboard';
import StripeAddonRevenueTool from './StripeAddonRevenueTool';
import StripeDashboard from './StripeDashboard';
import SubscriberDemographics from './SubscriberDemographics';
import SupportDashboard from './SupportDashboard';
import AnalyticsErrorBoundary from './components/AnalyticsErrorBoundary';

const Analytics = () => {
  return (
    <AnalyticsErrorBoundary
      fallbackTitle="Analytics Unavailable"
      fallbackMessage="Unable to load analytics dashboard"
    >
      <Routes>
        <Route
          path="/"
          element={
            <AnalyticsErrorBoundary
              fallbackTitle="Dashboard Hub Error"
              fallbackMessage="Unable to load analytics dashboard hub"
            >
              <AnalyticsMain />
            </AnalyticsErrorBoundary>
          }
        />
        <Route
          path="/sales"
          element={
            <AnalyticsErrorBoundary
              fallbackTitle="Sales Dashboard Error"
              fallbackMessage="Unable to load sales dashboard data"
            >
              <SalesDashboard />
            </AnalyticsErrorBoundary>
          }
        />
        <Route
          path="/stripe"
          element={
            <AnalyticsErrorBoundary
              fallbackTitle="Stripe Dashboard Error"
              fallbackMessage="Unable to load Stripe MRR dashboard data"
            >
              <RequirePermission permission="analytics.stripe.view">
                <StripeDashboard />
              </RequirePermission>
            </AnalyticsErrorBoundary>
          }
        />
        <Route
          path="/stripe/addon-revenue"
          element={
            <AnalyticsErrorBoundary
              fallbackTitle="Add-on Revenue Tool Error"
              fallbackMessage="Unable to load add-on revenue tool"
            >
              <RequirePermission permissions={['analytics.stripe.view', 'stripe.addons.manage']}>
                <StripeAddonRevenueTool />
              </RequirePermission>
            </AnalyticsErrorBoundary>
          }
        />
        <Route
          path="/support"
          element={
            <AnalyticsErrorBoundary
              fallbackTitle="Support Dashboard Error"
              fallbackMessage="Unable to load support dashboard data"
            >
              <SupportDashboard />
            </AnalyticsErrorBoundary>
          }
        />
        <Route
          path="/onboarding"
          element={
            <AnalyticsErrorBoundary
              fallbackTitle="Onboarding Dashboard Error"
              fallbackMessage="Unable to load onboarding dashboard data"
            >
              <OnboardingDashboard />
            </AnalyticsErrorBoundary>
          }
        />
        <Route
          path="/subscriber-demographics"
          element={
            <AnalyticsErrorBoundary
              fallbackTitle="Subscriber Health Dashboard Error"
              fallbackMessage="Unable to load subscriber demographics data"
            >
              <SubscriberDemographics />
            </AnalyticsErrorBoundary>
          }
        />
        <Route
          path="/db-stats"
          element={
            <AnalyticsErrorBoundary
              fallbackTitle="Database Statistics Dashboard Error"
              fallbackMessage="Unable to load database statistics data"
            >
              <DbStatsDashboard />
            </AnalyticsErrorBoundary>
          }
        />
        <Route
          path="/billing-readiness"
          element={
            <AnalyticsErrorBoundary
              fallbackTitle="Billing Readiness Error"
              fallbackMessage="Unable to load billing readiness report"
            >
              <BillingReadinessReport />
            </AnalyticsErrorBoundary>
          }
        />
        <Route
          path="/:dashboardId"
          element={
            <AnalyticsErrorBoundary
              fallbackTitle="Dashboard Error"
              fallbackMessage="Unable to load analytics dashboard data"
            >
              <AnalyticsDashboard />
            </AnalyticsErrorBoundary>
          }
        />
      </Routes>
    </AnalyticsErrorBoundary>
  );
};

export default Analytics;
